export default {
    active: true,
    seed: 14,
    skyType: "gradient",
    skyColor: "#091b39",
    horizonColor: "#284a9e",
    lighting: "distant",
    lightPosition: { x: -0.72, y: 0.62, z: 0.4 },
    fog: 0.8,
    flatShading: false,
    playArea: 1,
    ground: "spikes",
    groundYScale: 4.91,
    groundTexture: "none",
    groundColor: "#061123",
    groundColor2: "#694439",
    dressing: "towers",
    dressingAmount: 5,
    dressingColor: "#fb000e",
    dressingScale: 15,
    dressingVariance: { x: 20, y: 20, z: 20 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0,
    grid: "1x1",
    gridColor: "#fb000e",
    shadow: false,
};
